import { useCartProducts, useCombinedProductData } from "@design-lab/entities/product";
import { useCompositionPricing } from "@design-lab/entities/composition";
import { ProductPricing } from "@design-lab/features/manage-product-sizing/ui/ProductPricing";
import { AddToCartToolbar } from "@design-lab/features/add-to-cart";
import { useResponsive } from "@design-lab/shared/hooks/useResponsive";

export function AddToCart() {
  const { shirtCount } = useCartProducts();
  const { isLoading } = useCombinedProductData();
  const { totalPriceWithBulkDiscount, savings } = useCompositionPricing();
  const { isMobile } = useResponsive();

  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:pt-0">
      {!isMobile && (
        <ProductPricing
          isLoading={isLoading}
          salePrice={totalPriceWithBulkDiscount}
          savings={savings}
          shirtCount={shirtCount}
        />
      )}

      <AddToCartToolbar />
    </div>
  );
}
